import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromHelpStore from './help-store.reducer';

export const selectHelpStoreState = createFeatureSelector<fromHelpStore.State>(
    fromHelpStore.helpStoreFeatureKey
);

export const selectHelpVM = createSelector(selectHelpStoreState, (state) => ({
    details: state.helpDetails,
}));
